import { render, staticRenderFns } from "./ProductWarranty.vue?vue&type=template&id=1c27f2cc&scoped=true&"
import script from "./ProductWarranty.vue?vue&type=script&lang=js&"
export * from "./ProductWarranty.vue?vue&type=script&lang=js&"
import style0 from "./ProductWarranty.vue?vue&type=style&index=0&id=1c27f2cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c27f2cc",
  null
  
)

export default component.exports